import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { Element } from 'react-scroll';
import { propArrayShape, propBool, propShape, propStr, } from '../../../../../../helpers/custom-prop-types';
import Select2FieldsComponent from '../../../../../Ui/Common/Fields/Select2Fields/Select2FieldsComponent';
/**
 * セミナー申し込みのテキストコンポーネント
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const SeminarOneFormSelectField = (props) => {
    const { candidateValues, className, disabled, input, meta, placeholder } = props;
    const customStyles = useMemo(() => ({
        control: {
            background: '#F9F9F9',
            border: '1px solid #D8D8D8',
            borderRadius: '0',
        },
        singleValue: {
            color: 'rgb(0, 0, 0)',
            fontWeight: 'normal',
            margin: '7px 0 8px',
        },
        valueContainer: {
            fontSize: '14px',
            height: '40px',
            paddingLeft: '16px',
        },
    }), []);
    return (_jsx(Element, Object.assign({ className: className, name: `${input.name}_view` }, { children: _jsx("div", Object.assign({ className: 'client_seminar_one_form_select' }, { children: _jsx("div", Object.assign({ className: 'select_inner field' }, { children: _jsx(Select2FieldsComponent, { candidateValues: candidateValues, classNamePrefix: 'select_input', customStyles: customStyles, input: input, isDisabled: disabled, isMulti: false, isSearchable: false, maximum: 0, meta: meta, placeholder: placeholder }) })) })) })));
};
SeminarOneFormSelectField.propTypes = {
    candidateValues: propArrayShape().isRequired,
    className: propStr(),
    disabled: propBool(),
    input: propShape().isRequired,
    meta: propShape().isRequired,
    placeholder: propStr(),
};
SeminarOneFormSelectField.defaultProps = {
    className: '',
    disabled: false,
    placeholder: '',
};
export default SeminarOneFormSelectField;
